'use strict';

angular.module('app.accountDetails', [])
    .controller('accountDetailsCtrl', ['$scope', '$rootScope', '$http', '$modalInstance', '$modal', 'adminService', 'accountDetailsService', 'userAndBillingOverviewService', 'subscriptionAndBillingService',
        function ($scope, $rootScope, $http, $modalInstance, $modal, adminService, accountDetailsService, userAndBillingOverviewService, subscriptionAndBillingService) {

            $scope.diffAddBox = false;
            var definitions = angular.copy($rootScope.definitions);
            $scope.mailingCountries = definitions.countries;
            $scope.billingCountries = definitions.countries;

            $scope.getAccountDetails = function () {
                accountDetailsService.getAccountDetails($scope.current_account.id, true)
                    .then(function (response) {
                        $scope.selectedAccount = response.data;
                        $scope.vat = response.data.vat;
                        $scope.accountName = response.data.name;

                        if (response.data.user_id != null) {
                            accountDetailsService.getUserById(response.data.user_id, false)
                                .then(function (responseContactPerson) {
                                    $scope.contactPerson = responseContactPerson.data;
                                }, function (responseContactPerson) {
                                    var errorModalInstance = $modal.open({
                                        scope: $scope,
                                        templateUrl: 'app/common/partials/errorMessageBox.html?app_v=deployDate',
                                        windowClass: 'modal-dialog-mention-error'
                                    });
                                    $scope.errorModalInstance = errorModalInstance;
                                    $scope.errorMessage = responseContactPerson.message;
                                })
                        } else {
                            $scope.tempUserFirstName = response.data.temp_user_first_name;
                            $scope.tempUserPhone = response.data.temp_user_phone;
                            $scope.tempUserEmail = response.data.temp_user_email;
                        }

                        accountDetailsService.getAccountAddresses(response.data.id, false)
                            .then(function (responseAccountAddresses) {
                                angular.forEach(responseAccountAddresses.data, function (address) {
                                    if (address.type.id == 1) {
                                        angular.forEach($scope.mailingCountries, function (maillingCountry) {
                                            if (maillingCountry.id == address.country_id.id) {
                                                $scope.selectedMailingCountry = maillingCountry;
                                                maillingCountry.ticked = true;
                                            }
                                        })

                                        $scope.mailingStreet = address.street;
                                        $scope.mailingCity = address.city;
                                        $scope.mailingZipCode = address.zip_code;

                                        if (address.isDiffAddr != null && address.isDiffAddr != undefined) {
                                            $scope.diffAddBox = address.isDiffAddr == 1 ? true : false;
                                        }
                                    } else {
                                        angular.forEach($scope.billingCountries, function (billingCountry) {
                                            if (billingCountry.id == address.country_id.id) {
                                                $scope.selectedBillingCountry = billingCountry;
                                                billingCountry.ticked = true;
                                            }
                                        })

                                        $scope.billingStreet = address.street;
                                        $scope.billingCity = address.city;
                                        $scope.billingZipCode = address.zip_code;

                                        if (address.isDiffAddr != null && address.isDiffAddr != undefined) {
                                            $scope.diffAddBox = address.isDiffAddr == 1 ? true : false;
                                        }
                                    }
                                })


                            }, function (responseAccountAddresses) {
                                var errorModalInstance = $modal.open({
                                    scope: $scope,
                                    templateUrl: 'app/common/partials/errorMessageBox.html?app_v=deployDate',
                                    windowClass: 'modal-dialog-mention-error'
                                });
                                $scope.errorModalInstance = errorModalInstance;
                                $scope.errorMessage = responseAccountAddresses.message;
                            })
                    }, function (response) {
                        var errorModalInstance = $modal.open({
                            scope: $scope,
                            templateUrl: 'app/common/partials/errorMessageBox.html?app_v=deployDate',
                            windowClass: 'modal-dialog-mention-error'
                        });
                        $scope.errorModalInstance = errorModalInstance;
                        $scope.errorMessage = response.message;
                    })
            }

            $scope.getAccountTypes = function () {
                userAndBillingOverviewService.getAccountTypes(false)
                    .then(function (responseAccountTypes) {
                        $scope.accountTypes = responseAccountTypes.data;
                        angular.forEach($scope.accountTypes, function (accountType) {
                            if (accountType.id == $scope.current_account.companyType) {
                                $scope.selectedAccountType = accountType;
                                accountType.ticked = true;
                            }
                        })
                    }, function (responseAccountTypes) {
                        var errorModalInstance = $modal.open({
                            scope: $scope,
                            templateUrl: 'app/common/partials/errorMessageBox.html?app_v=deployDate',
                            windowClass: 'modal-dialog-mention-error'
                        });
                        $scope.errorModalInstance = errorModalInstance;
                        $scope.errorMessage = responseAccountTypes.message;
                    })
            }

            $scope.getAllGoverningAgency = function () {
                accountDetailsService.getAllGoverningAgency(false)
                    .then(function (responseGoverningAgencies) {
                        $scope.governingAgencies = responseGoverningAgencies.data;

                        accountDetailsService.getGoverningAgencyByCompany($scope.current_account.id, false)
                            .then(function (responseGoverningAgencyByCompany) {
                                $scope.currentAgency = responseGoverningAgencyByCompany.data;
                                angular.forEach($scope.governingAgencies, function (agency) {
                                    if (agency.id == $scope.currentAgency.id) {
                                        $scope.selectedGoverningAgency = $scope.currentAgency;
                                        agency.ticked = true;
                                    }
                                })
                            }, function (responseGoverningAgencyByCompany) {
                                var errorModalInstance = $modal.open({
                                    scope: $scope,
                                    templateUrl: 'app/common/partials/errorMessageBox.html?app_v=deployDate',
                                    windowClass: 'modal-dialog-mention-error'
                                });
                                $scope.errorModalInstance = errorModalInstance;
                                $scope.errorMessage = responseGoverningAgencyByCompany.message;
                            })

                    }, function (responseGoverningAgencies) {
                        var errorModalInstance = $modal.open({
                            scope: $scope,
                            templateUrl: 'app/common/partials/errorMessageBox.html?app_v=deployDate',
                            windowClass: 'modal-dialog-mention-error'
                        });
                        $scope.errorModalInstance = errorModalInstance;
                        $scope.errorMessage = responseGoverningAgencies.message;
                    })
            }

            $scope.updateAccount = function (params) {
                var params = {
                    accountId: $scope.current_account.id,
                    accountType: $scope.selectedAccountType ? $scope.selectedAccountType.id : null,
                    vat: $scope.vat,
                    accountName: $scope.accountName,
                    mailingStreet: $scope.mailingStreet,
                    mailingCity: $scope.mailingCity,
                    mailingZipCode: $scope.mailingZipCode,
                    mailingCountry: $scope.selectedMailingCountry ? $scope.selectedMailingCountry.id : null,
                    isDiffAddress: $scope.diffAddBox == true ? 1 : 0,
                    billingStreet: $scope.diffAddBox == true ? $scope.billingStreet : $scope.mailingStreet,
                    billingCity: $scope.diffAddBox == true ? $scope.billingCity : $scope.mailingCity,
                    billingZipCode: $scope.diffAddBox == true ? $scope.billingZipCode : $scope.mailingZipCode,
                    billingCountry: $scope.diffAddBox == true 
                                        ? ($scope.selectedBillingCountry && $scope.selectedBillingCountry.id) 
                                        : ($scope.selectedMailingCountry && $scope.selectedMailingCountry.id),
                    governingAgency: $scope.selectedGoverningAgency ? $scope.selectedGoverningAgency.id : null,
                    contactPersonId: $scope.contactPerson != null ? $scope.contactPerson.id : null,
                    contactPersonName: $scope.contactPerson != null ? $scope.contactPerson.firstName : null,
                    contactPersonPhone: $scope.contactPerson != null ? $scope.contactPerson.phone : null,
                    contactPersonEmail: $scope.contactPerson != null ? $scope.contactPerson.email : null,
                    autoCreateAccountForInfluencerOrNetwork: false,
                    influencerId: null,
                    networkId: null,
                    packageId: $scope.selectedPackageId,
                    tempUserFirstName: $scope.tempUserFirstName,
                    tempUserPhone: $scope.tempUserPhone,
                    tempUserEmail: $scope.tempUserEmail
                }

                accountDetailsService.updateAccount(params, true)
                    .then(function (responseSaveCompanyDetails) {
                        $scope.companyDetailsModalInstance.close();

                        if ($scope.current_account.id === $scope.currentUser.company.id) {
                            location.reload(true);
                        } else {
                            $scope.preLoadData();
                        }
                    }, function (responseSaveCompanyDetails) {
                        var errorModalInstance = $modal.open({
                            scope: $scope,
                            templateUrl: 'app/common/partials/errorMessageBox.html?app_v=deployDate',
                            windowClass: 'modal-dialog-mention-error'
                        });
                        $scope.errorModalInstance = errorModalInstance;
                        $scope.errorMessage = responseSaveCompanyDetails.message;
                    })
            }

            $scope.getAccountTypes();
            $scope.getAllGoverningAgency();
            $scope.getAccountDetails();

        }])